export const common = {
  nav: {
    home: 'ホーム',
    about: '会社概要',
    services: 'サービス',
    muviSpace: 'MuVi Space',
    equipment: '機材レンタル',
    locations: '店舗情報',
    contact: 'お問い合わせ',
    login: 'ログイン',
    account: 'マイページ',
    profile: 'プロフィール',
    orders: '注文履歴',
    notifications: '通知設定',
    logout: 'ログアウト',
    logoutError: 'ログアウトに失敗しました',
    user: 'ユーザー',
    language: '言語切替'
  },
  footer: {
    about: 'LensBankについて',
    aboutDesc: '10年以上の専門機材レンタル経験、国内外の映画人との長年の信頼関係',
    quickLinks: 'クイックリンク',
    services: 'サービス',
    contact: '連絡先',
    phone: '電話',
    email: 'メール',
    address: '住所',
    followUs: 'フォロー',
    poweredBy: 'PowerAslan'
  },
  common: {
    learnMore: '詳しく見る',
    viewDetails: '詳細を見る',
    bookNow: '今すぐ予約',
    submit: '送信',
    cancel: 'キャンセル',
    confirm: '確認',
    save: '保存',
    edit: '編集',
    delete: '削除',
    search: '検索',
    filter: 'フィルター',
    reset: 'リセット',
    loading: '読み込み中...',
    noData: 'データがありません'
  },
  contact: {
    pageTitle: 'お問い合わせ',
    pageDesc: '機材レンタル、長期契約、プロジェクトのご相談など、以下のフォームよりお気軽にお問い合わせください',
    formTitle: '協力相談フォーム',
    successMessage: 'フォームが正常に送信されました！できるだけ早くご連絡いたします。',
    errorMessage: '送信に失敗しました。後でもう一度お試しいただくか、直接お電話でお問い合わせください。',
    companyName: '会社名/団体名',
    companyNamePlaceholder: '会社名または団体名を入力してください',
    contactName: 'ご担当者名',
    contactNamePlaceholder: 'ご担当者名を入力してください',
    phone: '電話番号',
    phonePlaceholder: '例：090-1234-5678',
    email: 'メールアドレス',
    emailPlaceholder: 'example@company.com',
    cooperationType: '協力タイプ（複数選択可）',
    cooperationTypes: {
      shortTerm: '短期レンタル',
      longTerm: '長期レンタル',
      production: '撮影制作',
      crew: 'スタッフ派遣',
      enterprise: '企業プラン',
      education: '教育機関',
      other: 'その他'
    },
    budget: '予算範囲',
    budgetPlaceholder: '予算範囲を選択してください',
    budgetOptions: {
      under10: '10万円以下',
      range1030: '10-30万円',
      range3050: '30-50万円',
      range50100: '50-100万円',
      over100: '100万円以上',
      discuss: '要相談'
    },
    startDate: '利用開始予定日',
    rentalDuration: 'レンタル期間',
    rentalDurationPlaceholder: '選択してください',
    rentalDurationOptions: {
      days13: '1-3日',
      days47: '4-7日',
      weeks12: '1-2週間',
      weeks24: '2-4週間',
      month1plus: '1ヶ月以上',
      longTerm: '長期契約'
    },
    requirements: 'ご要望内容',
    requirementsPlaceholder: 'ご要望をご記入ください。例：必要な機材の種類、撮影用途、特別なご要望など...',
    maxChars: '最大500文字',
    source: 'どこで知りましたか？',
    sourcePlaceholder: '選択してください',
    sourceOptions: {
      search: 'インターネット検索',
      social: 'SNS',
      friend: '友人の紹介',
      reputation: '業界の評判',
      event: '展示会・イベント',
      other: 'その他'
    },
    submitButton: 'フォームを送信',
    submitting: '送信中...',
    contactInfo: '連絡先情報',
    phoneLabel: '電話',
    emailLabel: 'メール',
    lineLabel: 'LINE公式アカウント',
    businessHours: '営業時間',
    weekdays: '月曜日～日曜日',
    hours: '09:00 - 18:00',
    urgentService: '緊急対応サービス',
    urgentServiceDesc: '緊急のご要望がございましたら、お電話またはLINEにて直接ご連絡ください。優先的に対応させていただきます。',
    required: '*'
  },
  adminNav: {
    dashboard: 'ダッシュボード',
    orders: '注文管理',
    customers: '顧客管理',
    equipment: '機材管理',
    equipmentList: '機材一覧',
    equipmentItems: '品目管理',
    categories: 'カテゴリー',
    brands: 'ブランド',
    accessories: 'アクセサリー',
    locations: '拠点管理',
    vehicles: '車両管理',
    urent: 'Urent管理',
    urentApplications: '申請一覧',
    urentLedger: '取引明細',
    urentContracts: '契約管理',
    prepaid: 'チャージ顧客',
    prepaidApplications: '申請一覧',
    prepaidCustomers: '顧客一覧',
    prepaidLedger: '取引明細',
    prepaidPlans: 'プラン管理',
    analytics: '業績レポート',
    attendance: '出勤管理',
    schedules: 'シフト管理',
    aiAgent: 'AI / Runtime管理',
    serviceCases: '事例動画管理',
    contracts: '契約管理',
    legalSettings: '会社データ設定',
    forms: 'フォーム管理',
    cms: 'CMS',
    frontendImages: 'フロント画像管理',
    muviSpace: 'MuVi Space',
    muviBookings: '予約管理',
    muviContent: 'コンテンツ管理',
    muviSettings: '設定',
    milestones: 'マイルストーン管理',
    admins: '管理者管理',
    settings: 'システム設定',
    googleCalendar: 'Google Calendar',
    lineNotify: 'LINE Notify',
    apiSettings: 'API設定',
    storefrontSort: 'ストアフロント商品並び順設定',
    systemGovernance: 'システムガバナンス情報',
  },
  adminNavGroups: {
    frontendVisual: 'フロント表示管理',
    dailyOps: '日常業務',
    productManagement: '商品管理',
    customerManagement: '顧客管理',
    legalContracts: '法務 / 契約',
    accountingReports: '会計 / レポート',
    systemManagement: 'システム管理',
  },
  orderGovernance: {
    phasePreContract: '契約前',
    phaseActiveRental: '契約発効中',
    phaseTerminal: '完了・クローズ済み',
    contractActive: '契約発効',
    riskTransferred: 'リスク移転済み',
    restrictedRollback: 'ステータス復元制限',
    legalHold: '法務保全',
    earlyPickupApproval: '早期受取承認',
    abnormalFlow: '異常フロー',
    overdue: '期限超過',
    disputed: '紛争処理中',
    approvedNotReady: '注文受理済み',
    approvedNotReadyDesc: '注文は受理されましたが、機材の準備完了を意味しません。受取可能状態には別途明示的な操作/イベントが必要です。',
    rentalActiveTitle: '契約発効中 — リスク移転済み',
    rentalActiveDesc: '機材は引き渡し済みで、レンタル契約が発効し、責任とリスクはお客様に移転しています。',
    cannotOrdinaryCancel: '通常キャンセル不可',
    rollbackNeedsManager: 'ロールバックには店長以上の承認が必要',
    rollbackAlternative: 'キャンセルは返却・紛争・合意終了フローを使用してください。',
    canonicalState: '正規ステータス',
    legacyStatus: 'レガシーステータス',
    pickupGovernance: '受取ガバナンス',
    notificationEvent: '通知イベント',
    readyForPickupBlocked: 'ready_for_pickup 自動推定をブロック済み',
    pendingBackend: 'Mock / Pending backend',
    needInfoAdminLabel: '補足資料必要 / 審査中',
    needInfoCustomerLabel: '追加情報が必要です。店舗のご案内に従ってください。',
    completedWarning: '返却/完了フローは実行済みですが、法的保全のクローズには別途確認が必要です。',
  },
  aiAgent: {
    pageTitle: 'AI / Runtime 管理センター',
    pageSubtitle: '実行ガバナンス — プロバイダー状態、通知テンプレート、配達記録、AI対話ガバナンス',
    tabOverview: '概要',
    tabProviders: '通知チャネル',
    tabNotifications: '通知イベント',
    tabTemplates: '通知テンプレート',
    tabDeliveries: '配達記録',
    tabConversations: '対話記録',
    tabAudit: 'ツール監査',
    tabPolicies: 'ガバナンスポリシー',
    tabDeadLetters: '未配達 / 保留',
    mockBanner: '模擬データ — バックエンド未接続',
    sourcePendingBanner: 'バックエンド接続待ち',
    realDataLabel: 'リアルデータ接続済み',
    mockDataLabel: '模擬データ',
    tokenConfigured: 'Token 設定済み',
    tokenNotConfigured: 'Token 未設定',
    environment: '環境',
    lastWebhook: '最後の Webhook',
    lastDelivery: '最後の配達',
    deadLetters: '未配達メッセージ',
    maxCallsPerDay: '1日の上限',
    providerStatusSummary: '通知チャネル状態概要',
    runtimeArchitecture: 'Runtime アーキテクチャ',
    notificationRuntime: '通知 Runtime',
    aiConversationRuntime: 'AI 対話 Runtime',
    deliveryLog: '通知配達記録',
    deadLetterQueue: '未配達 / 保留キュー',
    internalOperations: '内部運営',
    customerOrders: '顧客注文通知',
    previewText: 'プレビュー文',
    allowedVariables: '使用可能変数',
    forbiddenNote: '禁止事項',
    safeResponse: '安全レスポンス',
    retryCount: '再試行回数',
    eventType: 'イベントタイプ',
    terminalReason: '終了理由',
    retryEligible: '再試行可能',
    safePayload: '安全ペイロード概要',
    providerCategory: '通知チャネル',
    deliveryCategory: '配達',
    securityCategory: 'セキュリティ',
    privacyCategory: 'プライバシー',
    noTokenDisplay: 'Provider token はこのページで表示・入力しません',
    tokenOnlyInSecret: 'Token は Railway / Supabase Secret にのみ保存',
    toolCallAuditLog: 'ツール呼び出し監査記録',
    conversationLog: '対話記録',
    statusEnabled: '有効',
    statusDisabled: '無効',
    ruleEnabled: '有効',
    ruleDisabled: '無効',
    deliveryModeDisabled: '無効',
    deliveryModeFake: 'Fake モード',
    deliveryModeDryRun: 'ドライラン モード',
    eventTypeLabel: 'イベントタイプ',
    providerPurposeLabel: 'チャネル用途',
    audienceScopeLabel: '対象',
    maxCallsLabel: 'イベントあたり上限',
    templateKeyLabel: 'テンプレート Key',
    confirmationTitle: '通知ルール変更確認',
    confirmationLine1: '通知ルール設定のみ変更されます。',
    confirmationLine2: 'LINE メッセージは送信されません。',
    confirmationLine3: 'live order hook はトリガーされません。',
    confirmationLine4: '通知イベントは作成されません。',
    auditTitle: '通知ルール変更履歴',
    auditAction: 'アクション',
    auditChangedFields: '変更フィールド',
    auditReasonCode: '理由コード',
    auditActorRole: '実行者ロール',
    auditTimestamp: 'タイムスタンプ',
    noRulesTitle: '通知ルールがまだありません',
    noRulesDesc: 'owner / super_admin が disabled / fake / dry-run ルールを作成できます。',
    permissionDeniedRules: '通知ルールを表示する権限がありません',
    sourcePendingRules: 'バックエンド接続待ち',
    modeMock: 'モック',
    modeDryRun: 'ドライラン',
    modeRealStaging: 'ステージング',
    modeProduction: '本番',
    restrictedView: '運営サマリーのみ表示（技術詳細は非表示）',
    adminOnlyTechnical: '技術詳細はシステム統括ロールのみ閲覧可能',
  },
  analytics: {
    pageTitle: '分析センター',
    pageSubtitle: 'ソース：admin-analytics-read — 読み取り専用、調達／廃棄実行なし',
    loading: '分析データを読み込んでいます...',
    empty: '条件に合う分析データがありません',
    scoped: 'このロールは授権かれた範囲内の運営サマリーのみ閲覧できます',
    error: '分析データを読み込めません。後でもう一度お試しください',
    permissionDenied: 'この分析データを閲覧する権限がありません',
    sourcePending: 'バックエンド接続待ち',
    mockData: 'モックデータ',
    suggestionOnly: '提案のみ、自動実行なし',
    humanReviewRequired: '人工レビュー必要',
    notExecutable: '実行機能はまだ開放されていません',
    revenueSectionTitle: '売上概要',
    revenueSectionNote: '運営的収益のみ、最終会計数字ではありません',
    storeSectionTitle: '店舗パフォーマンス',
    productSectionTitle: '製品パフォーマンス',
    productSectionNote: '製品レベルのみ、個別シリアル番号機材の判断には使用しない',
    itemAssetSectionTitle: '機材資産',
    itemAssetSectionNote: 'シリアル番号はマスク対応、完全な番号は表示しません',
    procurementSectionTitle: '調達候補',
    retirementSectionTitle: '廃棄 / 賞売候補',
    aiSummarySectionTitle: 'AI 安全サマリーデータ',
    aiSummarySectionNote: 'AI分析はまだ有効ではありません',
  },
  storefrontSort: {
    pageTitle: 'ストアフロント商品並び順設定',
    pageSubtitle: 'ストアフロント商品一覧のデフォルト並び順戦略と利用可能な並び順オプションを設定',
    pendingBanner: 'バックエンド接続待ち',
    pendingDesc: 'admin-storefront-sort-settings-read / update API はまだデプロイされていません。現在はUIプレビューのみです。',
    scopeTitle: '影響範囲の説明',
    scopeCopy1: 'この設定はストアフロント商品一覧（/equipment、カテゴリ、ブランド、検索結果）にのみ影響し、管理画面の製品管理リストの検索/フィルタ/並び順には影響しません。',
    scopeCopy2: 'ストアフロント並び順の適用には別の storefront integration gate が必要です；本ページは現在並び順戦略のみ管理します。',
    strategyCardTitle: '並び順戦略設定',
    defaultSortMode: 'デフォルト並び順モード',
    defaultSortModeHint: 'デフォルトモードは並び順オプションで有効のままにする必要があります。',
    enabledSortModes: '有効な並び順オプション（顧客向け）',
    enabledSortModesHint: 'チェックを外すと、そのオプションはストアフロントの並び順ドロップダウンから非表示になります。デフォルトモードは無効にできません。',
    featuredFirst: 'おすすめ商品を優先表示',
    featuredFirstDesc: '有効にすると、おすすめ/注目商品が一覧の先頭に表示されます',
    directionControls: '方向制御',
    fixedDirection: '固定',
    auditTitle: '変更履歴',
    auditEmpty: 'バックエンド接続待ち — 変更履歴はまだありません',
    auditEmptyHint: 'admin-storefront-sort-settings-audit-read API デプロイ後に最近の変更が表示されます。',
    saveSettings: '設定を保存',
    saving: '保存中...',
    previewOnly: 'すべての変更はこのページでのプレビューのみであり、バックエンドへの書き込みやストアフロント並び順への影響はありません。',
    savePending: '保存機能はバックエンド接続待ちです',
  }
};
